import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type TaskViewConfigFragment = { name: string, visible: boolean, label: string, order: number, width: number, editable: boolean, entityId?: string | null, entityType?: Types.UserViewFieldEntityTypeEnum | null, provider?: Types.IntegrationProviderEnum | null, iconSettings?: { type: Types.IconTypeEnum, value: string } | null, tagEntitySettings?: { disableGrouping?: boolean | null } | null };


export type TaskViewConfigFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const TaskViewConfigFragmentDoc = /*#__PURE__*/ gql`
    fragment TaskViewConfig on UserViewFieldSchema {
  name
  iconSettings {
    type
    value
  }
  visible
  label
  order
  width
  editable
  entityId
  entityType
  provider
  tagEntitySettings {
    disableGrouping
  }
}
    `;